import { SortButtonComponent } from './sort-button.component';

export default angular
  .module('sfMobile.components.sort-button', ['pascalprecht.translate'])
  .component('sfSortButton', SortButtonComponent).name;
